var _g, _rect, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPepsiNavbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 110,
    viewBox: "0 0 96 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2146_21956)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 54,
    r: 24,
    fill: "#005CBC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2146_21956",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 38,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 38,
    width: 32,
    height: 32,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2146_21956)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6742 58.8263C49.9718 52.2654 44.6045 44.8769 37.2874 43.9637L37.2999 43.874C44.5134 43.874 50.0434 50.9138 50.0434 56.4675C50.0365 57.6236 49.9499 58.3399 49.7954 58.86L49.6742 58.8263ZM49.2371 59.6603C48.7572 60.2785 48.1536 60.9009 47.4464 61.4918C46.1454 53.6042 40.6472 46.707 36.7599 44.6939L36.6767 44.7551C40.586 48.1373 45.2488 54.7062 47.062 61.8012C46.1371 62.5174 45.138 63.1206 44.084 63.599C40.3949 59.1642 36.9557 50.6114 35.8474 45.184L35.7347 45.2198C35.7597 50.4881 39.3078 59.4316 43.6348 63.7955C42.6424 64.2095 41.6107 64.51 40.5574 64.6919C36.4097 62.9597 33.4573 57.4118 33.4573 51.7287C33.4573 48.0187 34.5304 45.7236 34.738 45.2539L34.6496 45.217C34.3984 45.6175 32.8265 47.9114 32.8265 51.9167C32.8265 58.3406 35.8318 63.2508 39.8217 64.797C38.3949 64.9625 36.9523 64.8911 35.5465 64.5855L35.5168 64.6834C35.9436 64.849 37.3917 65.4898 39.6007 65.4898C44.5972 65.4898 47.9748 62.2173 49.3344 59.7297L49.2371 59.6603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1094 41.5557C35.3217 41.5557 30.8804 44.4374 30.8804 47.0715C30.8804 48.0904 31.7646 48.9512 33.5946 48.9512C37.8428 48.9512 41.7896 45.8745 41.7896 43.482C41.7896 42.223 40.6427 41.5557 39.1094 41.5557ZM40.6215 43.4076C40.6215 45.4243 36.9479 47.8895 33.877 47.8895C32.5202 47.8895 31.7871 47.3266 31.7871 46.3978C31.7871 44.3522 35.5025 41.9289 38.383 41.9289C40.261 41.9289 40.6215 42.9363 40.6215 43.4076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3432 48.2913C29.2367 48.4855 28.8104 49.3656 28.8104 50.2673C28.8104 51.9397 30.4133 53.4924 33.3617 53.4924C39.0336 53.4924 45.5867 49.0912 45.5867 45.0058C45.5867 43.1719 43.9399 42.1749 42.7966 41.9688L42.7751 42.0403C43.1307 42.1589 44.4335 42.7973 44.4335 44.4309C44.4335 47.6861 38.6477 52.1214 32.8845 52.1214C30.6781 52.1214 29.2881 50.9733 29.2881 49.3008C29.2881 48.7718 29.3925 48.4233 29.4202 48.3224L29.3432 48.2913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9536 45.3115C48.1091 45.436 49.0433 46.2568 49.0433 47.8089C49.0433 53.1012 41.1773 58.3053 34.2232 58.3053C30.0761 58.3053 28.1856 56.1467 28.2693 54.2301H28.3437C28.5062 55.2255 29.8527 57.0066 33.4823 57.0066C40.4451 57.0066 48.2194 51.6218 48.2194 46.9039C48.2194 46.0947 48.0109 45.5904 47.8931 45.3661L47.9536 45.3115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5641 50.252C50.5967 50.3647 50.7662 50.8713 50.7662 51.6648C50.7662 57.552 42.8057 62.592 35.8824 62.592C32.3191 62.592 30.4582 60.7673 30.0654 60.0263L30.1288 59.9769C31.1148 60.8859 33.0568 61.5766 35.3232 61.5766C41.4378 61.5766 50.5617 56.6726 50.4802 50.2734L50.5641 50.252Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2146_21956",
    x: -16,
    y: 0,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2146_21956"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2146_21956"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2146_21956",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPepsiNavbar);
export default __webpack_public_path__ + "static/media/PepsiNavbar.06e548fbc025eb90f4738b49f3bda932.svg";
export { ForwardRef as ReactComponent };